import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS } from '../../core/core.module';
import { Router } from '@angular/router';

@Component({
  selector: 'rpe-terminos-condiciones',
  templateUrl: './terminos-condiciones.component.html',
  styleUrls: ['./terminos-condiciones.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TerminosCondicionesComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onVolver() {
    this.router.navigate(['main', 'landing']);
  }
}
